import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { formatPrice } from '../../utils/helpers';
import { useSettings } from '../../context/SettingsContext';
import './CartBar.css';

const CartBar = () => {
  const location = useLocation();
  const { cartItemCount, cartTotal } = useCart();
  const { cartEnabled } = useSettings();

  // Nothing reaches the cart while orders go through WhatsApp, and a stale
  // pre-WhatsApp cart must not resurface a checkout link.
  if (!cartEnabled) {
    return null;
  }

  // Hide on checkout page
  if (location.pathname === '/checkout') {
    return null;
  }

  // Only show when there is something in the cart
  if (!cartItemCount || cartItemCount === 0) {
    return null;
  }

  return (
    <div className="cart-bar">
      <div className="cart-bar-content">
        <div className="cart-bar-info">
          <span className="cart-bar-items">
            {cartItemCount} {cartItemCount === 1 ? 'item' : 'items'}
          </span>
          <span className="cart-bar-total">
            Total: <strong>{formatPrice(cartTotal)}</strong>
          </span>
        </div>

        <div className="cart-bar-actions">
          <Link to="/cart" className="cart-bar-button secondary">
            View Cart
          </Link>
          <Link to="/checkout" className="cart-bar-button primary">
            Checkout
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CartBar;

